import { Box, Group, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { SettingsList } from "./SettingsList";

import { TextSerif } from "@/components/elements";

export const UserProfileTabSettings = () => {
  const { t } = useTranslation();

  return (
    <Box p="md">
      {/* Header */}
      <Group justify="space-between" align="center" h="2.5em">
        <Title order={3} fw="normal" fz="1.25em">
          {t("profile.user_settings")}
        </Title>
      </Group>

      <Box mb="lg">
        <TextSerif>{t("profile.settings_change_description")}</TextSerif>
      </Box>

      {/* Settings */}
      <Stack mt="lg">
        <Box maw="38.75em">
          <SettingsList />
        </Box>
      </Stack>
    </Box>
  );
};
